export default {
  namespaced: true,
  state: {
    /**
     * 提问内容
     * @type string
     */
    content: "",
    /**
     * 模型会话列表
     * @type Array
     */
    chat_record: [],
    /**
     * 会话索引
     * @type number
     */
    chat_index: -1,
    /**
     * 用于记录向导执行的列表
     * @type Array
     */
    wizard_step: [],
    /**
     * 用于记录上一步的路由信息
     */
    previous_history: undefined,
    is_resolve: null,
    kimi_3: "",
    kimi_2: "",
    kimi_4: "",
    gpt_3: "",
    gpt_2: "",
    gpt_4: "",
    capture_arr: [],
    step_num: 0,
    upload_file_type: [],
    current_step: null,
    current_is_first: true,
    is_show_wizard: false,
    last_content: false,
    content_list: [],
    ocr_int: false,
    previous_send_data: {},
  },
  mutations: {
    /**
     * 修改提问内容
     * @param state
     * @param content{string} 提问内容
     */
    set_content(state, content) {
      state.content = content;
    },
    /**
     * 修改会话索引
     * @param state
     * @param number{number} 索引值
     */
    set_chat_index(state, number) {
      state.chat_index = number;
    },
    /**
     * 修改当前会话的id
     * @param state
     * @param id
     */
    set_chat_id(state, id) {
      state.chat_record[state.chat_index]["id"] = id;
    },
    /**
     * 修改当前会话的名称
     * @param state
     * @param name
     */
    set_chat_name(state, name) {
      state.chat_record[state.chat_index]["name"] = name;
    },
    /**
     * 修改当前会话的回复内容
     * @param state
     * @param text{string} 回复内容
     * @param model_name{string} 回复的模型名称
     */
    set_chat_text(state, { text, model_name }) {
      state.chat_record[state.chat_index].record[model_name][
        state.chat_record[state.chat_index].record[model_name].length - 1
      ]["text"] += text;
    },
    /**
     * 修改当前会话的回复状态
     * @param state
     * @param is_end{boolean} 回复状态
     * @param model_name{string} 回复的模型名称
     */
    set_chat_is_end(state, { is_end, model_name }) {
      state.chat_record[state.chat_index].record[model_name][
        state.chat_record[state.chat_index].record[model_name].length - 1
      ]["is_end"] = is_end;
    },
    /**
     * 新增会话信息
     * @param state
     * @param val
     */
    push_chat_record(state, val) {
      state.chat_record.unshift(val);
    },
    set_chat_record_data(state, record) {
      state.chat_record[state.chat_index].record = record;
    },
    /**
     * 设置会话信息
     * @param state
     * @param val
     */
    set_chat_record(state, val) {
      state.chat_record = val;
    },
    /**
     * 追加指定模型回复
     * @param state
     * @param val
     * @param model_name
     */
    push_chat_record_model(state, { val, model_name }) {
      if (
        state.chat_record[state.chat_index].record[model_name] === undefined
      ) {
        state.chat_record[state.chat_index].record[model_name] = [val];
      } else {
        state.chat_record[state.chat_index].record[model_name].push(val);
      }
    },
    set_wizard_step(state, { key, val, index }) {
      if (state.wizard_step[index] === undefined) {
        state.wizard_step[index] = {
          ocr_model: "accuaate",
        };
      }
      state.wizard_step[index][key] = val;
    },
    empty_wizard_step(state) {
      state.wizard_step = [];
    },
    /**
     * 用于修改上一步的路由信息
     * @param state
     * @param from
     */
    set_previous_history(state, from) {
      state.previous_history = from;
    },
    set_previous_send_data(state, send_data) {
      state.previous_send_data = send_data;
    },

    set_user_info(state, info) {
      state.user_info = info;
    },
    set_ws(state, ws) {
      state.ws = ws;
    },
    //hfh begin
    set_is_resolve(state, target) {
      state.is_resolve = target;
    },
    set_capture_arr(state, target) {
      state.capture_arr = target;
    },

    set_step_num(state, target) {
      state.step_num = target;
    },
    delete_step_num(state) {
      state.step_num = state.step_num - 1;
    },
    add_upload_file_type(state, name) {
      state.upload_file_type.push(name);
    },
    remove_upload_file_type(state) {
      state.upload_file_type.splice(0);
    },
    set_current_step(state, target) {
      state.current_step = target;
    },
    set_current_is_first(state, target) {
      state.current_is_first = target;
    },
    set_is_show_wizard(state, target) {
      state.is_show_wizard = target;
    },
    set_last_content(state, target) {
      state.last_content = target;
    },
    set_content_list(state, target) {
      state.content_list = target;
    },
    set_ocr_int(state, val) {
      state.ocr_int = val;
    },
  },
  actions: {},
  getters: {},
};
